module.exports = __webpack_public_path__ + "static/media/ticket-off.dc6e2a2f.svg";